import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Notebook18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.1425 0.57044L15.1523 0.579176L16.8577 2.15608C17.3695 2.64208 17.3741 3.48219 16.868 3.97386L11.8101 9.08737C11.6978 9.20096 11.5521 9.27571 11.3943 9.30071L8.61738 9.74071C8.12258 9.81911 7.68112 9.37797 7.75917 8.88311L8.20866 6.03311C8.23334 5.87664 8.30693 5.73199 8.41887 5.61992L13.4133 0.619921C13.8791 0.153656 14.6508 0.131516 15.1425 0.57044ZM14.3107 1.84403L9.65238 6.50755L9.40157 8.09774L10.9166 7.85768L15.6448 3.07751L14.3107 1.84403Z'
      fill='currentColor'
    />
    <path
      d='M3.75 2.75H10V1.25H3.5C2.81917 1.25 2.25 1.81917 2.25 2.5V4.25H1V5.75H2.25V8.25H1V9.75H2.25V12.25H1V13.75H2.25V15.5C2.25 16.1808 2.81917 16.75 3.5 16.75H14.5C15.1808 16.75 15.75 16.1808 15.75 15.5V8.5H14.25V15.25H3.75V13.75H5V12.25H3.75V9.75H5V8.25H3.75V5.75H5V4.25H3.75V2.75Z'
      fill='currentColor'
    />
  </Svg>
);

Notebook18.displayName = 'Notebook18';
export default Notebook18;
